import React, { useContext, useState } from 'react';

import { ContextNotificacoes } from '../../../services/notificacoes';

import { ContextDestaques } from '../../../services/destaques';

import { ReactComponent as Business } from '../../../assets/novosicones/notificacoes/highlight.svg';

import { Spinner } from '../../StyledComponent';

import { useHistory } from 'react-router-dom';

const Destaques = ({ tema, setNotificationsModal }) => {
  const {
    marcarDestaqueLido,
    handleNotificationError,
    atualizaNotificacoes,
    CHECKIFNOTIFICATION,
  } = useContext(ContextNotificacoes);

  const { getAllDestaques } = useContext(ContextDestaques);

  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const NOTIFICATIONSDESTAQUES = JSON.parse(
    sessionStorage.getItem('notificationsDestaques')
  );

  async function redirectToDestaques() {
    let tempDestaques = [];
    let destaques = await getAllDestaques();

    for (let itemNotificacao of NOTIFICATIONSDESTAQUES) {
      tempDestaques = destaques.data.filter((destaque) => {
        return destaque.Id == itemNotificacao.IdSalesForce;
      });

      if (tempDestaques.length > 0) {
        history.push({
          pathname: '/destaques',
        });
        return;
      }
    }

    handleNotificationError();
  }

  const marcarDestaqueComoLido = async () => {
    for (let item of NOTIFICATIONSDESTAQUES) {
      if (!item.Visualizado) {
        await marcarDestaqueLido(item.Id);
      }
    }
  };

  const handleVisualizar = async () => {
    await marcarDestaqueComoLido();

    // recarrega os destaques para verificar se o destaque da notícia existe

    await atualizaNotificacoes();

    CHECKIFNOTIFICATION();
    redirectToDestaques();
    setLoading(false);
    setNotificationsModal(false);
  };

  let checkIfNewDestaque = [];

  if (NOTIFICATIONSDESTAQUES?.length > 0)
    checkIfNewDestaque = NOTIFICATIONSDESTAQUES.filter((item) => {
      return !item.Visualizado;
    });

  if (checkIfNewDestaque.length == 0) return null;

  return (
    <div className='notifications__item' style={{ marginTop: '24px' }}>
      <span
        className='notifications__item__title'
        style={{ color: tema.primaryColor }}
      >
        Destaques:
      </span>

      {NOTIFICATIONSDESTAQUES.length > 0 && (
        <div className='centralized-space-between'>
          <div className='centralized'>
            <span style={{ width: '24px', height: '24px', display: 'block' }}>
              <Business style={{ fill: tema.primaryColor }} />
            </span>
            <p
              className='notifications__item__description'
              style={{ color: '#454545' }}
            >
              Adicionamos informações importantes. Clique em Visualizar e
              confira!
            </p>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <a
              style={{ color: tema.primaryColor, cursor: 'pointer' }}
              onClick={() => {
                handleVisualizar();
                setLoading(true);
              }}
            >
              VISUALIZAR
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default Destaques;
